import { Component, HostBinding, OnInit } from '@angular/core';
import { TextBoxFormControl } from './text-box.control';
import { BasespaceStatus } from '../bs-app-launch-form-control';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-text-input-control',
  templateUrl: './bs-app-launch-text-input-control.component.html',
  styleUrls: ['./bs-app-launch-text-input-control.component.scss'],
})
export class BsAppLaunchTextInputControlComponent extends BsAppLaunchFormControlBaseComponent<TextBoxFormControl> implements OnInit {

  @HostBinding('attr.basespace-status')
  get basespaceStatus(): BasespaceStatus {
    return this.formControl ? this.formControl.basespaceStatus : null;
  }

  formControl: TextBoxFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit(): void {}

  onBlur(): void {
    this.checkAndFireFormUpdate();
  }

}
